import { Fragment } from 'react/jsx-runtime'

import { texts } from './texts'
import { Logo } from '@/view/components/ui/logo'

export function PolicyPrivacyPage() {
  return (
    <main className="flex flex-col items-center gap-4 p-5">
      <div className="mb-4">
        <Logo />
      </div>
      <h1 className="text-2xl font-bold uppercase">Política de Privacidade</h1>
      <div className="overflow-y-auto rounded-lg bg-gray-100 p-5">
        <p>
          {texts.map(({ paragraphy, text }) => (
            <Fragment key={paragraphy}>
              <strong>{paragraphy}</strong> {text}
              <br />
              <br />
            </Fragment>
          ))}
        </p>
      </div>
    </main>
  )
}
